// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"ed2df3db","142":"3f99a4e8","222":"cb39afd0","238":"6da3b7a8","869":"0bf74285","920":"8fa2b6d3"}[chunkId] + ".chunk.css";
};